export default {"src":"/_next/static/media/profile.fe4d89f4.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};